import { useQuery } from "@tanstack/react-query"

import { obterInstitucionalPublico } from "../services/institucionalApi"

export const CHAVE_INSTITUCIONAL_PUBLICO = ["cadastro", "institucional", "publico"] as const

/** Branding institucional (nome + disponibilidade de logo) para header/login. */
export function useInstitucionalPublico() {
  return useQuery({
    queryKey: CHAVE_INSTITUCIONAL_PUBLICO,
    queryFn: obterInstitucionalPublico,
    staleTime: 5 * 60_000,
    retry: 0,
  })
}
